/**
 * The plan names we sell, for the plan ids the server uses. The server's PRO is sold as Team and
 * its TEAM as Business (renamed 2026-10-08); a raw id on screen ("Your PRO plan") names a plan
 * nobody can buy.
 */
export const PLAN_NAMES = { FREE: 'Free', PRO: 'Team', TEAM: 'Business' };

export const planName = (plan) => PLAN_NAMES[plan] ?? plan;
